import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useState,
} from 'react';

import type { AssetTooltip } from '../entities/asset-tooltip';

export const AssetTooltipContext = createContext<
  [AssetTooltip | undefined, Dispatch<SetStateAction<AssetTooltip | undefined>>]
>(
  // @ts-expect-error - This is a placeholder value that should never be used
  undefined,
);

export function AssetTooltipProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const state = useState<AssetTooltip | undefined>(undefined);

  return (
    <AssetTooltipContext.Provider value={state}>
      {children}
    </AssetTooltipContext.Provider>
  );
}
